import { Avatar, Box } from '@primer/react';
import * as React from 'react';
export default {
  Avatar,
  Box,
  React
};